(() => {
  class AglProductTabs extends HTMLElement {
    connectedCallback() {
      const buttons = Array.from(this.querySelectorAll('[role="tab"]'));
      const panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      const setActive = (target) => {
        const id = target.getAttribute('aria-controls');
        buttons.forEach((btn) => {
          const selected = btn === target;
          btn.setAttribute('aria-selected', String(selected));
          btn.setAttribute('tabindex', selected ? '0' : '-1');
        });
        panels.forEach((panel) => {
          const active = panel.id === id;
          if (active) {
            panel.hidden = false;
          } else {
            panel.hidden = true;
          }
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          setActive(button);
          button.focus();
        });

        button.addEventListener('keydown', (event) => {
          let nextIndex = buttons.indexOf(button);
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIndex = (nextIndex + 1) % buttons.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIndex = (nextIndex - 1 + buttons.length) % buttons.length;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = buttons.length - 1;
          } else {
            return;
          }
          event.preventDefault();
          setActive(buttons[nextIndex]);
          buttons[nextIndex].focus();
        });
      });

      if (buttons.length) {
        buttons.forEach((btn, idx) => btn.setAttribute('tabindex', idx === 0 ? '0' : '-1'));
      }
    }
  }

  if (!customElements.get('agl-product-tabs')) {
    customElements.define('agl-product-tabs', AglProductTabs);
  }
})();
